// Persisted camera capture settings (burst, timelapse).
const KEY = "aiis-capture-settings";

export const BURST_COUNTS = [3, 5, 10];
export const BURST_GAPS_MS = [300, 600, 1000, 2000];
export const TL_INTERVALS_S = [1, 2, 3, 4, 5];
export const TL_SHOTS = [12, 24, 36, 72, 0]; // 0 = until stopped

export const DEFAULT_SETTINGS = { burstCount: 3, burstGapMs: 600, tlIntervalS: 2, tlShots: 24 };

export const loadSettings = () => {
  try {
    return { ...DEFAULT_SETTINGS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
};

export const saveSettings = (s) => {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* private mode */ }
};

// SKU from a scan: keep it filename/tag-safe.
export const cleanSku = (raw) => (raw || "").toString().trim().replace(/[^a-zA-Z0-9._-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
